var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "supplier bj" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c("el-button", {
          staticClass: "bjsearch",
          attrs: { type: "primary", icon: "el-icon-refresh" },
          on: { click: _vm.Refresh },
        }),
        _c(
          "div",
          { staticClass: "seach" },
          [
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入订单号", clearable: "" },
                  model: {
                    value: _vm.from1.order_no,
                    callback: function ($$v) {
                      _vm.$set(_vm.from1, "order_no", $$v)
                    },
                    expression: "from1.order_no",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-right": "10px" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    placeholder: "选择创建日期",
                  },
                  model: {
                    value: _vm.from1.as_at,
                    callback: function ($$v) {
                      _vm.$set(_vm.from1, "as_at", $$v)
                    },
                    expression: "from1.as_at",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入客户电话", clearable: "" },
                  model: {
                    value: _vm.from1.mobile,
                    callback: function ($$v) {
                      _vm.$set(_vm.from1, "mobile", $$v)
                    },
                    expression: "from1.mobile",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入售后单号", clearable: "" },
                  model: {
                    value: _vm.from1.as_no,
                    callback: function ($$v) {
                      _vm.$set(_vm.from1, "as_no", $$v)
                    },
                    expression: "from1.as_no",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.search },
              },
              [_vm._v("查询")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "warning", icon: "el-icon-upload2" },
                on: { click: _vm.exportHandle },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "auto-table-flex" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              data: _vm.tableData,
              height: "100%",
              border: true,
              "header-cell-style": { color: "#333333", background: "#EFF6FF" },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                width: "100px",
                align: "center",
                label: "序号",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "as_no", align: "center", label: "售后单号" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.$empty.empty(scope.row.as_no)) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "as_at", align: "center", label: "创建日期时间" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.$empty.time(scope.row.as_at)) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "order_no", align: "center", label: "订单号" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.$empty.empty(scope.row.order_no)) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "name", align: "center", label: "客户姓名" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return scope.row.order && scope.row.order.member
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$empty.empty(
                                    scope.row.order.member.fullname
                                  )
                                ) +
                                " "
                            ),
                          ]
                        : undefined
                    },
                  },
                ],
                null,
                true
              ),
            }),
            _c("el-table-column", {
              attrs: { prop: "name", align: "center", label: "客户电话" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return scope.row.order && scope.row.order.member
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$empty.empty(
                                    scope.row.order.member.mobile
                                  )
                                ) +
                                " "
                            ),
                          ]
                        : undefined
                    },
                  },
                ],
                null,
                true
              ),
            }),
            _c("el-table-column", {
              attrs: { prop: "remark", align: "center", label: "客服备注" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return scope.row.order
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$empty.empty(scope.row.order.remark)
                                ) +
                                " "
                            ),
                          ]
                        : undefined
                    },
                  },
                ],
                null,
                true
              ),
            }),
            _c("el-table-column", {
              attrs: { label: "操作", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "router-link",
                        {
                          staticClass: "main-color pointer text-none",
                          attrs: {
                            to: {
                              name: "tdcafterDetail",
                              query: {
                                id: scope.row.id,
                                state: 1,
                                word: "detail",
                              },
                            },
                          },
                        },
                        [_vm._v("查看详情 ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "fy" },
      [
        _c("el-pagination", {
          attrs: {
            type: "primary",
            background: "",
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _vm.from1.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }